import React from "react";

// Message de bienvenue aux 150 premiers inscrits (1 fois par membre).
// Deux variantes : "new" pour ceux qui arrivent, "existing" pour les membres
// deja la au moment du lancement de l'offre — eux, on les remercie.
// Autonome (aucune dependance app) pour rester robuste ; rouge de marque en dur.
//
// Le numero affiche est profiles.member_no : il est attribue a l'inscription et
// ne bouge jamais. On annonce donc un fait verifiable, pas une categorie floue.

// Ordinal : l'allemand, l'espagnol, l'italien, le portugais et le neerlandais
// ont une forme unique ; seuls le francais et l'anglais ont des exceptions.
function ordinal(n, lang) {
  if (lang === "fr") return n === 1 ? "1er" : n + "e";
  if (lang === "en") {
    const r10 = n % 10, r100 = n % 100;
    if (r10 === 1 && r100 !== 11) return n + "st";
    if (r10 === 2 && r100 !== 12) return n + "nd";
    if (r10 === 3 && r100 !== 13) return n + "rd";
    return n + "th";
  }
  if (lang === "de") return n + ".";
  if (lang === "es") return "n.º " + n;
  if (lang === "it") return n + "°";
  if (lang === "pt") return n + "º";
  if (lang === "nl") return n + "e";
  return String(n);
}

const I18N = {
  fr: {
    titleNew: "Bienvenue dans l'aventure 🐴",
    titleOld: "Merci d'être là depuis le début 🐴",
    introNew: "Merci de nous rejoindre si tôt.",
    introOld: "Merci d'avoir rejoint HorseConnex aussi tôt.",
    born: "HorseConnex est un projet tout jeune, né dans une écurie entre deux séances.",
    rank: (o) => "Et vous êtes notre <b>" + o + " inscrit</b>.",
    why: "Ça compte plus que vous ne l'imaginez : à ce stade, ce sont les premiers qui font exister une application.",
    gift: "Alors quoi qu'il arrive : <b>l'application vous restera entièrement gratuite à vie.</b> Si HorseConnex devient payant un jour, cela ne vous concernera pas.",
    thanks: "Merci de croire en ce projet. 🐴",
    badges: "⭐ Membre fondateur · 👑 PRO MAX",
    cta: "C'est parti",
  },
  en: {
    titleNew: "Welcome aboard 🐴",
    titleOld: "Thanks for being here from the start 🐴",
    introNew: "Thank you for joining us so early.",
    introOld: "Thank you for joining HorseConnex so early.",
    born: "HorseConnex is a very young project, born in a stable between two rides.",
    rank: (o) => "And you are our <b>" + o + " member</b>.",
    why: "That matters more than you think: at this stage, it's the first members who bring an app to life.",
    gift: "So whatever happens: <b>the app will stay entirely free for you, for life.</b> If HorseConnex ever becomes paid, it won't apply to you.",
    thanks: "Thank you for believing in this project. 🐴",
    badges: "⭐ Founder Member · 👑 PRO MAX",
    cta: "Let's go",
  },
  de: {
    titleNew: "Willkommen an Bord 🐴",
    titleOld: "Danke, dass Sie von Anfang an dabei sind 🐴",
    introNew: "Danke, dass Sie so früh dabei sind.",
    introOld: "Danke, dass Sie HorseConnex so früh beigetreten sind.",
    born: "HorseConnex ist ein sehr junges Projekt, entstanden im Stall zwischen zwei Ausritten.",
    rank: (o) => "Und Sie sind unser <b>" + o + " Mitglied</b>.",
    why: "Das zählt mehr, als Sie denken: In dieser Phase sind es die Ersten, die eine App zum Leben erwecken.",
    gift: "Deshalb, was auch kommt: <b>die App bleibt für Sie lebenslang vollständig kostenlos.</b> Sollte HorseConnex eines Tages kostenpflichtig werden, betrifft es Sie nicht.",
    thanks: "Danke, dass Sie an dieses Projekt glauben. 🐴",
    badges: "⭐ Gründungsmitglied · 👑 PRO MAX",
    cta: "Los geht's",
  },
  es: {
    titleNew: "Bienvenido a la aventura 🐴",
    titleOld: "Gracias por estar aquí desde el principio 🐴",
    introNew: "Gracias por unirte tan pronto.",
    introOld: "Gracias por haberte unido a HorseConnex tan pronto.",
    born: "HorseConnex es un proyecto muy joven, nacido en una cuadra entre dos sesiones de monta.",
    rank: (o) => "Y eres nuestro miembro <b>" + o + "</b>.",
    why: "Eso importa más de lo que crees: en esta etapa, son los primeros quienes hacen existir una aplicación.",
    gift: "Así que pase lo que pase: <b>la aplicación seguirá siendo totalmente gratuita para ti, de por vida.</b> Si HorseConnex se vuelve de pago algún día, no te afectará.",
    thanks: "Gracias por creer en este proyecto. 🐴",
    badges: "⭐ Miembro fundador · 👑 PRO MAX",
    cta: "¡Vamos!",
  },
  it: {
    titleNew: "Benvenuto nell'avventura 🐴",
    titleOld: "Grazie di esserci fin dall'inizio 🐴",
    introNew: "Grazie per esserti unito così presto.",
    introOld: "Grazie di esserti iscritto a HorseConnex così presto.",
    born: "HorseConnex è un progetto giovanissimo, nato in scuderia tra un giro e l'altro.",
    rank: (o) => "E sei il nostro <b>" + o + " iscritto</b>.",
    why: "Conta più di quanto immagini: in questa fase sono i primi a far esistere un'applicazione.",
    gift: "Quindi qualunque cosa accada: <b>l'applicazione resterà per te completamente gratuita a vita.</b> Se un giorno HorseConnex diventerà a pagamento, non ti riguarderà.",
    thanks: "Grazie di credere in questo progetto. 🐴",
    badges: "⭐ Membro fondatore · 👑 PRO MAX",
    cta: "Iniziamo",
  },
  pt: {
    titleNew: "Bem-vindo à aventura 🐴",
    titleOld: "Obrigado por estares aqui desde o início 🐴",
    introNew: "Obrigado por te juntares a nós tão cedo.",
    introOld: "Obrigado por te teres juntado ao HorseConnex tão cedo.",
    born: "O HorseConnex é um projeto muito jovem, nascido numa cavalariça entre dois treinos.",
    rank: (o) => "E és o nosso <b>" + o + " inscrito</b>.",
    why: "Isso conta mais do que imaginas: nesta fase, são os primeiros que fazem uma aplicação existir.",
    gift: "Por isso, aconteça o que acontecer: <b>a aplicação continuará totalmente gratuita para ti, para sempre.</b> Se o HorseConnex se tornar pago um dia, isso não te dirá respeito.",
    thanks: "Obrigado por acreditares neste projeto. 🐴",
    badges: "⭐ Membro fundador · 👑 PRO MAX",
    cta: "Vamos lá",
  },
  nl: {
    titleNew: "Welkom bij het avontuur 🐴",
    titleOld: "Bedankt dat je er vanaf het begin bij bent 🐴",
    introNew: "Bedankt dat je zo vroeg meedoet.",
    introOld: "Bedankt dat je je zo vroeg bij HorseConnex hebt aangesloten.",
    born: "HorseConnex is een piepjong project, ontstaan in de stal tussen twee ritten door.",
    rank: (o) => "En jij bent ons <b>" + o + " lid</b>.",
    why: "Dat telt meer dan je denkt: in deze fase zijn het de eersten die een app tot leven brengen.",
    gift: "Dus wat er ook gebeurt: <b>de app blijft voor jou levenslang volledig gratis.</b> Mocht HorseConnex ooit betalend worden, dan geldt dat niet voor jou.",
    thanks: "Bedankt dat je in dit project gelooft. 🐴",
    badges: "⭐ Oprichtend lid · 👑 PRO MAX",
    cta: "Aan de slag",
  },
};

export default function FounderNotice({ lang = "fr", memberNo, variant = "new", onClose }) {
  const t = I18N[lang] || I18N.fr;
  const showRank = Number.isFinite(memberNo) && memberNo > 0;

  return (
    <div onClick={onClose} style={{
      position:"fixed", inset:0, zIndex:2000, background:"rgba(0,0,0,.6)",
      display:"flex", alignItems:"center", justifyContent:"center", padding:20,
    }}>
      <div onClick={e=>e.stopPropagation()} style={{
        width:"100%", maxWidth:400, background:"#1A1A2E", color:"#fff",
        borderRadius:18, padding:"24px 22px 18px", border:"1px solid rgba(255,255,255,.12)",
        boxShadow:"0 20px 50px rgba(0,0,0,.5)", textAlign:"center",
        maxHeight:"90vh", overflowY:"auto",
      }}>
        <div style={{ fontSize:20, fontWeight:900, fontFamily:"var(--fh)", marginBottom:14, lineHeight:1.3 }}>
          {variant === "existing" ? t.titleOld : t.titleNew}
        </div>

        <div style={{ fontSize:14, color:"rgba(255,255,255,.8)", lineHeight:1.65, marginBottom:14 }}>
          {variant === "existing" ? t.introOld : t.introNew}
        </div>

        <div style={{ fontSize:14, color:"rgba(255,255,255,.8)", lineHeight:1.65, marginBottom:14 }}>
          {t.born}
          {showRank && (
            <> <span dangerouslySetInnerHTML={{ __html: t.rank(ordinal(memberNo, lang)) }} /></>
          )}
        </div>

        <div style={{ fontSize:14, color:"rgba(255,255,255,.8)", lineHeight:1.65, marginBottom:16 }}>
          {t.why}
        </div>

        <div style={{
          fontSize:14, color:"#fff", lineHeight:1.65, marginBottom:16,
          background:"rgba(200,0,26,.14)", border:"1px solid rgba(200,0,26,.35)",
          borderRadius:13, padding:"14px 15px",
        }} dangerouslySetInnerHTML={{ __html: t.gift }} />

        <div style={{ fontSize:14, color:"rgba(255,255,255,.8)", lineHeight:1.65, marginBottom:16 }}>
          {t.thanks}
        </div>

        <div style={{
          fontSize:12.5, fontWeight:800, color:"#F5A623", fontFamily:"var(--fh)",
          background:"rgba(245,166,35,.12)", border:"1px solid rgba(245,166,35,.3)",
          borderRadius:11, padding:"9px 12px", marginBottom:18,
        }}>{t.badges}</div>

        <button onClick={onClose} style={{
          width:"100%", padding:"13px 20px", borderRadius:13, border:"none", cursor:"pointer",
          background:"#C8001A", color:"#fff", fontSize:15, fontWeight:800, fontFamily:"var(--fh)",
          boxShadow:"0 8px 22px rgba(200,0,26,.45)",
        }}>{t.cta}</button>
      </div>
    </div>
  );
}
